import { useEffect, useState } from 'react';
import InputSelect from '../../../../../../component/inputSelect/InputSelect';
import ImageUpload from '../../../../../../component/uplaodImage';
import InputField from '../../../../../../component/form/FormInput';
import { newObjectCreater } from '../../../../../../utils/controller';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import Navigation from '../../../customers/createCustomer/Navigation';
import OtherDetails from '../otherDetails';
import Address from '../../../customers/createCustomer/Address';
import DoctorDocuments from './doctorDocuments';
import { getDoctortypes } from '../../../../../../services/doctors';

const DoctorForm = ({
	setDoctorData,
	doctorData,
	doctorDocs,
	setDoctorDocs,
	activeTab,
	setActiveTab,
	error,
	setError,
	isEdit,
	setIsEditProfile,
	cityList,
}) => {
	const [doctorTypeList, setDoctorTypeList] = useState([]);

	const param = useParams();
	const id = param?.id;
	const [autofocus, setAutofocus] = useState(false);
	const [doctorDisplayNameList, setDoctorDisplayNameList] = useState([]);
	const validateEmail = (value) => {
		const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return regex.test(value);
	};

	async function getDoctorTypeList() {
		try {
			var { doctor } = await getDoctortypes();
			var doctorTypes = newObjectCreater(doctor?.types);
			setDoctorTypeList(doctorTypes);
		} catch (error) {
			toast.error(error);
		}
	}

	const handleDoctorRemarkChange = (key, value) => {
		setDoctorData((prev) => ({
			...prev,
			doctorRemark: {
				[key]: value,
			},
		}));
	};

	const handleDoctorDataChangeWithValidation = (key, value) => {
		setDoctorData((prev) => ({
			...prev,
			basicDetails: {
				...prev.basicDetails,
				[key]: value,
			},
		}));

		var errorData = { ...error };
		if (key === 'doctor_name' && (value === '' || value === undefined)) {
			errorData['doctor_name'] = 'Please enter doctor name in the field';
		} else {
			delete errorData['doctor_name'];
		}
		if (key === 'business_name' && (value === '' || value === undefined)) {
			errorData['business_name'] = 'Please enter business name in the field';
		} else {
			delete errorData['business_name'];
		}

		if (key === 'doctor_display_name' && (value === '' || value === undefined)) {
			errorData['doctor_display_name'] = 'Please select valid doctor display name in the list';
		} else {
			delete errorData['doctor_display_name'];
		}
		if (key === 'doctor_phone_work' || key === 'doctor_phone_mobile') {
			if (value) {
				if (value.length > 10 || value.length < 10) {
					errorData[key] =
						`Please enter valid ${key === 'doctor_phone_work' ? 'Phone Work' : 'Phone Mobile'} number`;
				} else {
					delete errorData[key];
				}
			} else {
				delete errorData[key];
			}
		}
		if (key === 'doctor_email') {
			if (value) {
				if (validateEmail(value)) {
					delete errorData['doctor_email'];
				} else {
					errorData['doctor_email'] = 'Please enter valid email address';
				}
			} else {
				delete errorData['doctor_email'];
			}
		}

		setError(errorData);
	};

	const handleImageUpload = (imageFile) => {
		setIsEditProfile(true);
		setDoctorData((prev) => ({
			...prev,
			basicDetails: {
				...prev.basicDetails,
				profile_url: imageFile,
			},
		}));
	};

	const handleDisplayDoctorNameList = () => {
		const data = [
			{ key: doctorData.basicDetails.doctor_name, value: doctorData.basicDetails.doctor_name },
			{ key: doctorData.basicDetails.business_name, value: doctorData.basicDetails.business_name },
		];
		setDoctorDisplayNameList(data);
	};

	useEffect(() => {
		getDoctorTypeList();
	}, []);

	useEffect(() => {
		handleDisplayDoctorNameList();
	}, [doctorData.basicDetails.doctor_name, doctorData.basicDetails.business_name]);

	useEffect(() => {
		if (!autofocus) {
			setAutofocus(true);
		}
	}, [autofocus]);

	return (
		<div className="max-w-1297 px-3">
			<div className="row">
				<div className="col-5 mt-4">
					<InputSelect
						options={doctorTypeList || []}
						placeholder="Select Doctor Type"
						label="Doctor Type"
						autoComplete="off"
						onChange={(value) => {
							if (value === null || value === '') {
								handleDoctorDataChangeWithValidation('doctor_type_id', value);
							}
						}}
						onSelect={(value) => handleDoctorDataChangeWithValidation('doctor_type_id', value.key)}
						value={doctorData.basicDetails.doctor_type_id}
						disabled={isEdit}
						required={false}
						error={error?.doctor_type_id}
						autoFocus={isEdit === false ? autofocus : false}
					/>
				</div>
				<div className="col-5 mt-4">
					<InputField
						label="Doctor Name"
						placeholder="Doctor Name"
						autoComplete="off"
						onChange={(valueData) => {
							const value = valueData.replace(/[^A-Za-z\s']/g, '');
							handleDoctorDataChangeWithValidation('doctor_name', value);
						}}
						value={doctorData.basicDetails.doctor_name}
						disabled={isEdit}
						required={true}
						error={error?.doctor_name}
					/>
				</div>
				<div className="col">
					<ImageUpload
						imageUrl={doctorData.basicDetails.profile_url}
						onImageUpload={handleImageUpload}
						error={error?.image}
						disabled={isEdit}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-6">
					<div style={{ position: 'relative' }}>
						<InputField
							label="Business Name"
							placeholder="Business Name"
							autoComplete="off"
							key="text"
							value={doctorData.basicDetails.business_name}
							onChange={(value) => {
								handleDoctorDataChangeWithValidation('business_name', value);
							}}
							required={true}
							disabled={isEdit}
							error={error?.business_name}
						/>
					</div>
				</div>
				<div className="col-6">
					<InputSelect
						options={doctorDisplayNameList || []}
						placeholder="Select Doctor Display Name"
						label="Doctor Display Name"
						autoComplete="off"
						onChange={(value) => {
							if (value === null || value === '') {
								handleDoctorDataChangeWithValidation('doctor_display_name', value.key);
							}
						}}
						onSelect={(value) =>
							handleDoctorDataChangeWithValidation('doctor_display_name', value.key)
						}
						value={doctorData.basicDetails.doctor_display_name}
						disabled={isEdit}
						required={true}
						error={error?.doctor_display_name}
					/>
				</div>
			</div>
			<div
				className="row"
				style={{ marginTop: '10px' }}
			>
				<div className="col-6">
					<InputField
						label="Email"
						autoComplete="off"
						placeholder="Email"
						value={doctorData.basicDetails.doctor_email}
						onChange={(value) => handleDoctorDataChangeWithValidation('doctor_email', value)}
						key="text"
						disabled={isEdit}
						error={error.doctor_email}
					/>
				</div>

				<div className="col-3">
					<InputField
						label="Phone(Work)"
						placeholder="Phone(Work)"
						autoComplete="off"
						maxLength={10}
						value={doctorData.basicDetails.doctor_phone_work}
						onChange={(valueData) => {
							var value = valueData?.replace(/[^0-9]/g, '');
							handleDoctorDataChangeWithValidation('doctor_phone_work', value);
						}}
						key="text"
						disabled={isEdit}
						error={error.doctor_phone_work}
					/>
				</div>

				<div className="col-3">
					<InputField
						label="Phone(Mobile)"
						placeholder="Mobile Number"
						autoComplete="off"
						key="text"
						maxLength={10}
						value={doctorData.basicDetails.doctor_phone_mobile}
						onChange={(valueData) => {
							var value = valueData?.replace(/[^0-9]/g, '');
							handleDoctorDataChangeWithValidation('doctor_phone_mobile', value);
						}}
						disabled={isEdit}
						error={error.doctor_phone_mobile}
					/>
				</div>
			</div>
			<Navigation
				activeTab={activeTab}
				setActiveTab={setActiveTab}
			/>
			{activeTab === 'Other Details' && (
				<OtherDetails
					data={doctorData.othersDetails}
					setData={setDoctorData}
					error={error}
					setError={setError}
					disabled={isEdit}
				/>
			)}
			{activeTab === 'Address' && (
				<Address
					data={doctorData.address}
					setData={setDoctorData}
					error={error}
					cityList={cityList}
					disabled={isEdit}
				/>
			)}
			{activeTab === 'Remarks' && (
				<InputField
					label="Remark"
					placeholder="Remark"
					value={doctorData.doctorRemark.remark_text}
					onChange={(value) => handleDoctorRemarkChange('remark_text', value)}
					key="text"
					disabled={isEdit}
				/>
			)}
			{activeTab === 'Upload Documents' && (
				<DoctorDocuments
					setDoctorDocs={setDoctorDocs}
					doctorDocs={doctorDocs}
					doctorId={id}
				/>
			)}
		</div>
	);
};
export default DoctorForm;
